import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import WatchingMediaProfileMetric from './watching-media-profile-metric-model'
import {
  CreateWatchingMediaProfileMetricAsync,
  DeleteWatchingMediaProfileMetricAsync,
  LoadWatchingMediaProfileMetricsAsync,
} from './watchingMediaProfileMetric-thunk'
const initialState: watchingMediaProfileMetricSliceState = {
  watchingMediaProfileMetric: [],
  selected_watchingMediaProfileMetric: '',
  is_loading_watchingMediaProfileMetric: false,
  is_creating_watchingMediaProfileMetric: false,
  is_deleting_watchingMediaProfileMetric: false,
}
export interface watchingMediaProfileMetricSliceState {
  watchingMediaProfileMetric: WatchingMediaProfileMetric[]
  selected_watchingMediaProfileMetric?: string
  is_loading_watchingMediaProfileMetric: boolean
  is_creating_watchingMediaProfileMetric: boolean
  is_deleting_watchingMediaProfileMetric: boolean
}
export const watchingMediaProfileMetricSlice = createSlice({
  name: 'watchingMediaProfileMetric',
  initialState,
  reducers: {
    setSelectedwatchingMediaProfileMetric: (state, action) => {
      state.selected_watchingMediaProfileMetric = action.payload
    },
    clearStatewatchingMediaProfileMetric: (state) => {
      state.watchingMediaProfileMetric = []
      state.is_loading_watchingMediaProfileMetric = false
      state.is_creating_watchingMediaProfileMetric = false
      state.is_deleting_watchingMediaProfileMetric = false
    },
    mergewatchingMediaProfileMetric: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_watchingMediaProfileMetric = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.watchingMediaProfileMetric = merge(
            state.watchingMediaProfileMetric,
            payload,
          ) as any
        }
      }
    },

    add_watchingMediaProfileMetric: (state, action) => {
      if (action.payload) {
        state.watchingMediaProfileMetric = [
          ...state.watchingMediaProfileMetric,
          action.payload,
        ]
      }
    },
    set_watchingMediaProfileMetric: (state, action) => {
      let { key, value, id } = action.payload
      state.watchingMediaProfileMetric = state.watchingMediaProfileMetric.map(
        (item) => {
          if (item && item.id === id) {
            return {
              ...item,
              [key]: value,
            }
          }
          return item
        },
      )
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadWatchingMediaProfileMetricsAsync.pending, (state) => {
      state.is_loading_watchingMediaProfileMetric = true
    })
    builder.addCase(
      LoadWatchingMediaProfileMetricsAsync.fulfilled,
      (state, action) => {
        state.is_loading_watchingMediaProfileMetric = false
        if (action.payload) {
          state.watchingMediaProfileMetric = action.payload
        }
      },
    )
    builder.addCase(LoadWatchingMediaProfileMetricsAsync.rejected, (state) => {
      state.is_loading_watchingMediaProfileMetric = false
    })
    builder.addCase(CreateWatchingMediaProfileMetricAsync.pending, (state) => {
      state.is_creating_watchingMediaProfileMetric = true
    })
    builder.addCase(
      CreateWatchingMediaProfileMetricAsync.fulfilled,
      (state) => {
        state.is_creating_watchingMediaProfileMetric = false
      },
    )
    builder.addCase(CreateWatchingMediaProfileMetricAsync.rejected, (state) => {
      state.is_creating_watchingMediaProfileMetric = false
    })
    builder.addCase(DeleteWatchingMediaProfileMetricAsync.pending, (state) => {
      state.is_deleting_watchingMediaProfileMetric = true
    })
    builder.addCase(
      DeleteWatchingMediaProfileMetricAsync.fulfilled,
      (state, action) => {
        state.is_deleting_watchingMediaProfileMetric = false
        if (state.watchingMediaProfileMetric) {
          state.watchingMediaProfileMetric =
            state.watchingMediaProfileMetric.filter(
              (x) => action.payload.id !== x.id,
            )
        }
      },
    )
    builder.addCase(DeleteWatchingMediaProfileMetricAsync.rejected, (state) => {
      state.is_deleting_watchingMediaProfileMetric = false
    })
  },
})

export const {
  clearStatewatchingMediaProfileMetric,
  setSelectedwatchingMediaProfileMetric,
  set_watchingMediaProfileMetric,
  mergewatchingMediaProfileMetric,
  add_watchingMediaProfileMetric,
} = watchingMediaProfileMetricSlice.actions

export const get_watchingMediaProfileMetric =
  (id?: string) =>
  (state: {
    watchingMediaProfileMetric: {
      watchingMediaProfileMetric: WatchingMediaProfileMetric[]
    }
  }): WatchingMediaProfileMetric | null => {
    let temp =
      state?.watchingMediaProfileMetric?.watchingMediaProfileMetric?.find(
        (v) => v.id === id,
      )
    if (temp) {
      return temp
    }
    return (
      state?.watchingMediaProfileMetric?.watchingMediaProfileMetric[0] || null
    )
  }
export const get_selected_watchingMediaProfileMetric = (state: {
  watchingMediaProfileMetric: watchingMediaProfileMetricSliceState
}): WatchingMediaProfileMetric | null => {
  let id =
    state?.watchingMediaProfileMetric?.selected_watchingMediaProfileMetric
  let temp =
    state?.watchingMediaProfileMetric?.watchingMediaProfileMetric?.find(
      (v) => v.id === id,
    )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_watchingMediaProfileMetric = (state: {
  watchingMediaProfileMetric: {
    watchingMediaProfileMetric: WatchingMediaProfileMetric[]
  }
}): WatchingMediaProfileMetric[] => {
  let temp = state?.watchingMediaProfileMetric?.watchingMediaProfileMetric
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_watchingMediaProfileMetric_busy = (state: {
  watchingMediaProfileMetric: watchingMediaProfileMetricSliceState
}) => {
  return (
    state?.watchingMediaProfileMetric.is_deleting_watchingMediaProfileMetric ||
    state?.watchingMediaProfileMetric.is_loading_watchingMediaProfileMetric ||
    state?.watchingMediaProfileMetric.is_creating_watchingMediaProfileMetric
  )
}
export const is_deleting_watchingMediaProfileMetric_busy = (state: {
  watchingMediaProfileMetric: watchingMediaProfileMetricSliceState
}) => {
  return state?.watchingMediaProfileMetric
    .is_deleting_watchingMediaProfileMetric
}
export const is_loading_watchingMediaProfileMetric_busy = (state: {
  watchingMediaProfileMetric: watchingMediaProfileMetricSliceState
}) => {
  return state?.watchingMediaProfileMetric.is_loading_watchingMediaProfileMetric
}
export const is_creating_watchingMediaProfileMetric_busy = (state: {
  watchingMediaProfileMetric: watchingMediaProfileMetricSliceState
}) => {
  return state?.watchingMediaProfileMetric
    .is_creating_watchingMediaProfileMetric
}

export default watchingMediaProfileMetricSlice.reducer
